import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { KeyingAppEnvironmentConfig } from '../configuration/keying.app.environment.config'


@Injectable({
  providedIn: 'root',
})
export class RPAService {
  constructor(
    @Inject(HttpClient) private httpClient: HttpClient,
    private keyingAppEnvironmentConfig: KeyingAppEnvironmentConfig
  ) {}

  /* istanbul ignore next */ 
  getRPAStatus(rpaNumber) {
    const url = `${this.keyingAppEnvironmentConfig.getBaseUrl()}/RestrictedProduct?rpa=${rpaNumber}`
    return this.httpClient.get<any[]>(url)
  }
}
